import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import ActionableFilterPill from '../../index';

const getDisplayName = (appliedFilters, shipFroms) => {
  if (appliedFilters.length === 0) {
    return <FormattedMessage defaultMessage='Ship From' description='filterOptions.shipFrom' id='MY5gOS' />;
  }
  if (appliedFilters.length > 1) {
    return <FormattedMessage defaultMessage='(Multiple Ship From)' description='filterOptions.multipleShipFroms' id='3kuvPq' />;
  }
  const [filter] = appliedFilters;
  const matchingShipFrom = shipFroms.find((shipFrom) => shipFrom.shipFromId === filter.criterionArgumentValue);
  if (!matchingShipFrom) {
    return <FormattedMessage defaultMessage='Ship From' description='filterOptions.shipFrom' id='MY5gOS' />;
  }
  return matchingShipFrom.name;
};

const mapStateToProps = (state, ownProps) => {
  const shipFroms = Global.selectSellerShipFroms(state);
  const appliedFilters = Global.selectShipmentsFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });

  return {
    isSelected: !!appliedFilters.length,
    displayContent: getDisplayName(appliedFilters, shipFroms),
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
